import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get_Astro_Filter } from '../../../store/actions/CommanAction';
import DataTable from 'react-data-table-component';
import { Dropdown, Modal, Nav, Tab } from 'react-bootstrap';

const AstroFilter = () => {
    const dispatch = useDispatch();
    const AstroFilter = useSelector((state) => state.feedBackReducer.AstroFilter);

    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    useEffect(() => {
        
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedToday = `${yyyy}-${mm}-${dd}`;
    
        const defaultStartTime = `${formattedToday}`;
        const defaultEndTime = `${formattedToday}`;
    
        setStartTime(defaultStartTime);
        setEndTime(defaultEndTime);
    
        
        dispatch(get_Astro_Filter(formattedToday, formattedToday));
    }, [dispatch]);

    const handleSearch = () => {
        if (startTime && endTime) {
            const formatDate = (dateTime) => {
                if (!dateTime) return null;
                const date = new Date(dateTime);
                const yyyy = date.getFullYear();
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const dd = String(date.getDate()).padStart(2, '0');
                return `${yyyy}-${mm}-${dd}`;
            };

            const formattedStartDate = formatDate(startTime);
            const formattedEndDate = formatDate(endTime);

            const data = {
                FromDate: formattedStartDate,
                Todate: formattedEndDate,
            };


            dispatch(get_Astro_Filter(data.FromDate, data.Todate));

        } else {
            alert('Please select both Start Time and End Time');
        }
    };


    const columns = [
        {
            name: 'DisplayName', selector: (row) => row.DisplayName, sortable: true,
        },
        {
            name: 'RegMobileNo', selector: (row) => row.RegMobileNo, sortable: true,
        },
        {
            name: 'DOB', selector: (row) => row.DOB, sortable: true,
        },
        {
            name: 'Gender', selector: (row) => row.Gender, sortable: true,
        },
        {
            // width:'700px',
            name: 'PANCardNo', selector: (row) => row.PANCardNo, sortable: true,
        },
        {
            name: 'DregeeDiploma', selector: (row) => row.DregeeDiploma, sortable: true,
        },
        {
            name: 'Reviews', selector: (row) => row.Reviews, sortable: true,
        },
        {
            name: 'Rating', selector: (row) => row.Rating, sortable: true,
        },
    ];
    return (
        <div>

            <div className="form-group">
                <div className="d-flex justify-content-between mt-3">
                    <div className="" style={{ flex: 1,marginRight: '-400px' }}>
                        <label>Start Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={startTime}
                            style={{ width: '30%' }}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label>End Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={endTime}
                            style={{ width: '30%' }}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                    </div>
                </div>
                <button className="btn btn-primary mt-3" onClick={handleSearch}>
                    Search
                </button>
            </div>

            <div className="col-12 mt-2">
                <DataTable
                    dense
                    data={AstroFilter}
                    columns={columns}
                    selectableRowsHighlight
                    pagination
                    persistTableHead={true}
                    noDataComponent={"There are no data to display"}
                />
            </div>
        </div>
    );
};
export default AstroFilter;
